export default "__VITE_ASSET__DB2V2Us1__"